
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useCoordinateUpdates = () => {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const updateProfileCoordinates = async () => {
    try {
      setLoading(true);
      console.log('🔧 Manually updating profile coordinates...');
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        throw new Error('No authenticated user found');
      }

      const { error } = await supabase.rpc('manually_update_profile_coordinates' as any);

      if (error) {
        console.error('Manual coordinate update error:', error);
        throw error;
      }

      console.log('✅ Manual coordinate update completed');
      
      toast({
        title: "Coordinates Updated",
        description: "Profile coordinates have been updated based on your location.",
      });

    } catch (error: any) {
      console.error('❌ Error updating coordinates:', error);
      
      toast({
        title: "Update Error",
        description: error.message || "Failed to update profile coordinates",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    updateProfileCoordinates,
    loading
  };
};
